import React from 'react'

import { ComponentContainer } from 'shared/StyledComponents'
import WrapperDisabilityCheckboxField from 'shared/FormFields/WrapperDisabilityCheckboxField'
import DropdownField from 'shared/FormFields/DropdownField'

const DropdownFieldStyled = (props) => (
  <ComponentContainer dropdown>
    <DropdownField {...props} />
  </ComponentContainer>
)

const DisableableDropdownField = ({
  disabilityCheckboxName,
  dropdownsShareOfWidth,
  disabled,
  label,
  customCheckBoxOnChange,
  checkboxDisabledByDefault,
  ...restProps
}) => (
  <WrapperDisabilityCheckboxField
    WrappedComponent={DropdownFieldStyled}
    disCbFldProps={{
      name: disabilityCheckboxName,
      label,
      customCheckBoxOnChange,
      checkboxDisabledByDefault,
    }}
    wrappedCmpProps={restProps}
    wrappedCmpsShareOfWidth={dropdownsShareOfWidth}
    disabled={disabled}
  />
)

export default DisableableDropdownField
